import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'next/image';
import SwiperCore from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { MobilePackshotContainer, WrapperImage } from './MobilePackshot.style';
interface Props {
  data: string[];
}
const MobilePackshot = ({
  data
}: Props) => {
  SwiperCore.use([Pagination]);
  const packshotData = <Swiper pagination={{
    type: 'fraction'
  }} modules={[Pagination]} className="mySwiper">
            {data.map((imageUrl, index) => <SwiperSlide key={index}>
                    <WrapperImage>
                        <Image src={imageUrl || '/images/default/product.jpg'} alt="Product Image" onError={({
          currentTarget
        }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = '/images/default/product.jpg';
        }} placeholder="blur" blurDataURL="/images/default/product.jpg" width={390} height={390} priority={false} />
                    </WrapperImage>
                </SwiperSlide>)}
        </Swiper>;
  return <MobilePackshotContainer>{packshotData}</MobilePackshotContainer>;
};
export default MobilePackshot;